export default {
  name: 'marking--treeMrkUpdateUpload',
  apiService: 'shoes',
  apiPath: '/admin/treemrk/update/status/file',
  urlParamName: 'marking--treeMrkUpdateUpload',
};